import { useLocationSearch } from '@rocketlane/rocket-router';
import { CDN_BASE_URL } from 'config/environment';
import { RoutePaths } from 'constant';
import { TemplateObjectType } from 'data/templates/api';
import { ROUTE_PATHS } from 'routes/routes-paths';
export const getSpaceDetailUrl = ([, projectId, spaceId])=>{
    return `/projects/${projectId}/spaces/${spaceId}`;
};
export const getSpaceTabDetailUrl = ([, projectId, spaceId, spaceTabId])=>{
    return `/projects/${projectId}/spaces/${spaceId}/tabs/${spaceTabId}/`;
};
const ProjectsPrefix = '/projects';
export const getProjectDetailUrl = ([, projectId])=>{
    // `projectId` can be undefined during collection-backed hydration even though
    // the type says number. Fall back to the prefix so the helper never throws.
    if (projectId == null) {
        return ProjectsPrefix;
    }
    return RoutePaths.projectDetail.replace(/(:\w+\b)/, projectId.toString());
};
export const getProjectTasksUrl = (projectId)=>{
    return `${getProjectDetailUrl(projectId)}/tasks`;
};
export const getProjectFormResponseUrl = (projectId)=>{
    return `${getProjectDetailUrl(projectId)}/forms/responses`;
};
export const getProjectOverviewUrl = (projectId)=>{
    return `${getProjectDetailUrl(projectId)}/overview`;
};
export const getProjectAskAiUrl = (projectId, conversationId)=>{
    const baseUrl = `${getProjectDetailUrl(projectId)}/${ROUTE_PATHS.ASK_AI}`;
    if (conversationId) {
        return `${baseUrl}/${conversationId}`;
    }
    return baseUrl;
};
export const getProjectFinancialsUrl = (projectId)=>{
    return `${getProjectDetailUrl(projectId)}/financials`;
};
export const getProjectBudgetsUrl = (projectId)=>{
    return `${getProjectDetailUrl(projectId)}/budgets`;
};
export const getProjectPlanUrl = (projectId)=>{
    return `${getProjectDetailUrl(projectId)}/plan`;
};
export const getProjectConversationPageUrl = (projectId)=>{
    return `${getProjectDetailUrl(projectId)}/chat`;
};
export const getProjectSpacesUrl = (projectId)=>{
    return `${getProjectDetailUrl(projectId)}/spaces`;
};
export const getProjectTimesheetUrl = (projectId)=>{
    return `${getProjectDetailUrl(projectId)}/timesheet`;
};
export const getProjectInvoicesUrl = (projectId)=>{
    return `${getProjectDetailUrl(projectId)}/invoices`;
};
export const getProjectExpenseUrl = (projectId)=>{
    return `${getProjectDetailUrl(projectId)}/expense`;
};
export const getProjectExpenseReportUrl = (projectId)=>{
    return `${getProjectDetailUrl(projectId)}/expense-report`;
};
export const getProjectConversationDetailUrl = (projectId, chatId)=>{
    return `${getProjectDetailUrl(projectId)}/chat/${chatId[1]}`;
};
export const GlobalConversationSeparator = ':';
export const getProjectGlobalConversationDetailUrl = (projectId, entityId, entityType)=>{
    return `${getProjectDetailUrl(projectId)}/chat/${entityType}${GlobalConversationSeparator}${entityId}`;
};
export const getProjectStatusUpdatesUrl = (projectId)=>`${getProjectDetailUrl(projectId)}/status-updates`;
export const getProjectTaskListUrl = (projectId)=>{
    return `${getProjectTasksUrl(projectId)}/list`;
};
export const getProjectTaskBoardUrl = (projectId)=>{
    return `${getProjectTasksUrl(projectId)}/board`;
};
export const getProjectSettingsUrl = ([, projectId])=>{
    return `${ProjectsPrefix}/${projectId}/settings`;
};
export const getProjectFinancialsSettingsUrl = ([, projectId])=>{
    return `${ProjectsPrefix}/${projectId}/settings/budget-management`;
};
export const getProjectFormResponsesUrl = ([, projectId])=>{
    return RoutePaths.projectFormResponses.replace(':projectId', projectId.toString());
};
export const getProjectFormByInstanceUrl = ([, projectId, instanceId])=>{
    return RoutePaths.projectFormResponseByInstance.replace(':projectId', projectId.toString()).replace(':instanceId', instanceId.toString());
};
export const getProjectFilesUrl = ([, projectId])=>{
    return `${ProjectsPrefix}/${projectId}/files`;
};
export const getProjectSheetsUrl = ([, projectId])=>{
    return `${ProjectsPrefix}/${projectId}/sheets`;
};
export const getProjectNitroPagesUrl = ([, projectId])=>{
    return `${ProjectsPrefix}/${projectId}/nitro-pages`;
};
export const getProjectEmailPagesUrl = ([, projectId])=>{
    return `${ProjectsPrefix}/${projectId}/email-pages`;
};
export const getProjectEmailsUrl = ([, projectId])=>{
    return `${ProjectsPrefix}/${projectId}/emails`;
};
export const getProjectEmailMessageUrl = ([, projectId], emailMessageId)=>{
    return `${ProjectsPrefix}/${projectId}/emails/${emailMessageId}`;
};
export const getProjectMeetingPagesUrl = ([, projectId])=>{
    return `${ProjectsPrefix}/${projectId}/meeting-pages`;
};
export const getProjectSignalsV2Url = ([, projectId])=>{
    return `${ProjectsPrefix}/${projectId}/signals`;
};
export const getProjectCustomerPortalConfigurationUrl = ([, projectId])=>{
    return `${ProjectsPrefix}/${projectId}/customer-portal-configuration`;
};
const TemplatesPrefix = '/templates';
const templateTypePrefixMap = {
    [TemplateObjectType.Project]: 'projects',
    [TemplateObjectType.Document]: 'documents',
    [TemplateObjectType.StatusUpdates]: 'status-updates',
    [TemplateObjectType.Form]: 'forms'
};
export const getTemplateUrl = ([, templateId], type)=>{
    const typePrefix = templateTypePrefixMap[type];
    return `${TemplatesPrefix}/${typePrefix}/${templateId}`;
};
export const getSheetTemplateUrl = ([, templateId])=>{
    return `${TemplatesPrefix}/sheet/${templateId}`;
};
export const getTaskFieldEditUrl = (fieldId)=>{
    /* TODO:: can be replaced with regex: (:\w+\b) */ return RoutePaths.editTaskField.replace(':fieldId', fieldId.toString());
};
export const getProjectFieldEditUrl = (fieldId)=>{
    /* TODO:: can be replaced with regex: (:\w+\b) */ return RoutePaths.editProjectField.replace(':fieldId', fieldId.toString());
};
export const getTeamMemberFieldEditUrl = (fieldId)=>{
    /* TODO:: can be replaced with regex: (:\w+\b) */ return RoutePaths.editTeamMemberField.replace(':fieldId', fieldId.toString());
};
export const getSpintFieldEditUrl = (fieldId)=>{
    return RoutePaths.editSprintField.replace(':fieldId', fieldId.toString());
};
export const getEpicFieldEditUrl = (fieldId)=>{
    return RoutePaths.editEpicField.replace(':fieldId', fieldId.toString());
};
export const getInvoiceFieldEditUrl = (fieldId)=>{
    /* TODO:: can be replaced with regex: (:\w+\b) */ return RoutePaths.editInvoiceField.replace(':fieldId', fieldId.toString());
};
export const getTimeEntryFieldEditUrl = (fieldId)=>{
    /* TODO:: can be replaced with regex: (:\w+\b) */ return RoutePaths.editTimeEntryField.replace(':fieldId', fieldId.toString());
};
export const getExpenseFieldEditUrl = (fieldId)=>{
    /* TODO:: can be replaced with regex: (:\w+\b) */ return RoutePaths.editExpenseField.replace(':fieldId', fieldId.toString());
};
export const getAllocationFieldEditUrl = (fieldId)=>{
    /* TODO:: can be replaced with regex: (:\w+\b) */ return RoutePaths.editAllocationField.replace(':fieldId', fieldId.toString());
};
export const getCustomerTeamMemberFieldEditUrl = (fieldId)=>{
    /* TODO:: can be replaced with regex: (:\w+\b) */ return RoutePaths.editCustomerTeamMemberField.replace(':fieldId', fieldId.toString());
};
export const getCompanyFieldEditUrl = (fieldId)=>{
    /* TODO:: can be replaced with regex: (:\w+\b) */ return RoutePaths.editCompanyField.replace(':fieldId', fieldId.toString());
};
export const getSkillFieldEditUrl = (fieldId)=>{
    /* TODO:: can be replaced with regex: (:\w+\b) */ return RoutePaths.editSkillField.replace(':fieldId', fieldId.toString());
};
export const getKeyeventFieldEditUrl = (fieldId)=>{
    return RoutePaths.editKeyevent.replace(':eventId', fieldId.toString());
};
export const getIntervalFieldEditUrl = (fieldId)=>{
    return RoutePaths.editInterval.replace(':intervalId', fieldId.toString());
};
export const getBudgetFieldEditUrl = (fieldId)=>{
    /* TODO:: can be replaced with regex: (:\w+\b) */ return RoutePaths.editBudgetField.replace(':fieldId', fieldId.toString());
};
export const getProjectStatusUpdatesDetailUrl = (projectId, statusUpdateId)=>{
    return `/projects/${projectId}/status-updates/${statusUpdateId}`;
};
// https://regex101.com/r/sIQoje/1
export const URlRegEx = new RegExp('^(https?://)?(www.)?[a-z0-9]{1,}([-_.]{1}[a-z0-9]+)*([.][a-z]{2,64})(/{1}[a-z0-9]{1,}[a-z0-9%#_.?&~=*+-]*)*/?$', 'ig');
export const getNewWidgetUrl = (dashboardId, search = '')=>{
    return `${RoutePaths.newWidget.replace(':dashboardId', dashboardId.toString())}${search}`;
};
export const getDashboardUrl = (dashboardId)=>{
    return `/dashboards/${dashboardId}`;
};
export const getEditWidgetUrl = (dashboardId, widgetId)=>`widgets/${widgetId}/edit`;
export const getEditSheetWidgetUrl = (sheetTemplateId, widgetId)=>`overview/widgets/${widgetId}/edit-card`;
// use this dashboard url utils because the default utils overrides the query params of global filters
export const useGetDashboardUrlWithSearch = ()=>{
    const search = useLocationSearch();
    return (dashboardId)=>`${getDashboardUrl(dashboardId)}${search}`;
};
export const useGetEditWidgetUrlWithSearch = ()=>{
    const search = useLocationSearch();
    return (dashboardId, widgetId)=>`${getEditWidgetUrl(dashboardId, widgetId)}${search}`;
};
export const useGetEditSheetWidgetUrlWithSearch = ()=>{
    const search = useLocationSearch();
    return (sheetTemplateId, widgetId)=>`${getEditSheetWidgetUrl(sheetTemplateId, widgetId)}${search}`;
};
export const getProjectPreviewUrl = (projectId)=>{
    return `${getProjectDetailUrl(projectId)}/preview`;
};
export const getSalesforceBaseUrl = (integrationId)=>`${RoutePaths.salesforceIntegrationById.replace(':integrationId', integrationId)}`;
export const getSalesforceAutomationUrl = (integrationId)=>`${getSalesforceBaseUrl(integrationId)}/automations`;
export const getSalesforceNewAutomationUrl = (integrationId)=>`${getSalesforceBaseUrl(integrationId)}/automations/new`;
export const getSalesforceMappingsUrl = (integrationId)=>`${getSalesforceBaseUrl(integrationId)}/resource-mappings`;
export const getSalesforceSettingsUrl = (integrationId)=>`${getSalesforceBaseUrl(integrationId)}/settings`;
export const getSalesforceErrorLogsUrl = (integrationId)=>`${getSalesforceBaseUrl(integrationId)}/error-logs`;
export const getSalesforceAutomationEditUrl = (integrationId, automationId)=>`${getSalesforceBaseUrl(integrationId)}/automations/${automationId}/edit`;
export const getNetsuiteBaseUrl = (integrationId)=>`${RoutePaths.netsuiteIntegrationById.replace(':integrationId', integrationId)}`;
export const getNetsuiteAutomationUrl = (integrationId)=>`${getNetsuiteBaseUrl(integrationId)}/automations`;
export const getNetsuiteMappingsUrl = (integrationId)=>`${getNetsuiteBaseUrl(integrationId)}/resource-mappings`;
export const getNetsuiteSettingsUrl = (integrationId)=>`${getNetsuiteBaseUrl(integrationId)}/settings`;
export const getNetsuiteErrorLogsUrl = (integrationId)=>`${getNetsuiteBaseUrl(integrationId)}/error-logs`;
export const getHubspotBaseUrl = (integrationId)=>`${RoutePaths.hubspotIntegrationById.replace(':integrationId', integrationId)}`;
export const getHubspotSettingsUrl = (integrationId)=>`${getHubspotBaseUrl(integrationId)}/settings`;
export const getHubspotMappingsUrl = (integrationId)=>`${getHubspotBaseUrl(integrationId)}/resource-mappings`;
export const stripSlashes = (url)=>{
    // url should be single path name like `/templates/` not `/parent/child/`.
    return url.split('/').filter((i)=>i !== '/').join('');
};
export const getCustomerPreviewUrl = (path)=>`${path}`;
export const getFormResponsetaskDrawerurl = (projectId, taskId, answerId)=>`#task_drawer=${projectId}.${taskId}&task_drawer_tab=conversations&form_response_id=${answerId}`;
export const getCustomReportsUrl = (customReportId, customReportType, customReportQueryParams)=>`${RoutePaths.customReport.replace(':customReportType', customReportType).replace(':customReportId', customReportId.toString())}${customReportQueryParams || ''}`;
export const buildChildRouteUrl = (...segments)=>{
    return segments.join('/').replace(/\/+/g, '/') // Replace multiple slashes with a single slash
    .replace(/\/$/, '') // Remove trailing slash if any
    .replace(/^(.+)?$/, '/$1'); // Ensure the URL starts with a single slash
};
export const ASSETS_FOLDER_PROD = 'rocketlane-attachments-public';
export const ASSETS_FOLDER_STAGING = 'rocketlane-attachments-public-stage';
export const isCdnUrl = (url)=>{
    return url.startsWith(CDN_BASE_URL);
};
export const replaceWithCDNUrl = (oldUrl)=>{
    if (isCdnUrl(oldUrl) || !oldUrl.includes(ASSETS_FOLDER_PROD) && !oldUrl.includes(ASSETS_FOLDER_STAGING)) {
        return oldUrl;
    }
    const link = document.createElement('a');
    link.href = oldUrl;
    // Extract the path segments
    //* https://s3.us-east-1.amazonaws.com/rocketlane-attachments-public-stage/4337/3ebbc361-7f63-4d63-8cd9-688800bd5718/sysdig-2.png -> 4337/3ebbc361-7f63-4d63-8cd9-688800bd5718/sysdig-2.png
    const pathSegments = link.pathname.split('/').slice(2).join('/');
    return `${CDN_BASE_URL}/${pathSegments}`;
};
export const getProjectTemplateSettingsUrl = (templateId)=>{
    return RoutePaths.projectTemplateSettings.replaceAll(':templateId', templateId.toString());
};
export const getProjectFinancialRateCardSettingsUrl = (projectId)=>{
    return `${getProjectDetailUrl(projectId)}/settings/rate-cards`;
};
export const getProjectFinancialDefaultConfigurationSettingsUrl = (projectId)=>{
    return `${getProjectDetailUrl(projectId)}/settings/default-configuration`;
};
export const getProjectFinancialBudgetManagementSettingsUrl = (projectId, selectedBudgetId)=>{
    return `${getProjectDetailUrl(projectId)}/settings/budget-management${selectedBudgetId ? `/${selectedBudgetId}` : ''}`;
};
